import { render } from "./orders_completed_results.vue?vue&type=template&id=07e936a1&scoped=true"
import script from "./orders_completed_results.vue?vue&type=script&lang=js"
export * from "./orders_completed_results.vue?vue&type=script&lang=js"

import "./orders_completed_results.vue?vue&type=style&index=0&id=07e936a1&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07e936a1"]])

export default __exports__